import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import { logoutAction} from "../../redux/modules/login";
import {bindActionCreators} from "redux";
import { connect } from 'react-redux';
import {Redirect, Link} from "react-router-dom";




/* const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder),
    multilineColor:{
        color:'red'
    }

}); */

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    multilineColor:{
        color:'black',
        backgroundColor:'#f5f7e8'
    },
    buttonsignup: {
        marginTop: theme.spacing.unit * 11,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        width:'95%',
        color: "black",
        border:'2px solid green',
        borderColor:'black',
        height:40,
        fontSize:16,
        fontWeight:800,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    },
});


class Logout extends Component {

    state = {
        age: '',
        firstname: '',
        lastname:'',
        email:'',
        comment:'',
        userComment:{}
    };
    constructor(props) {
        super(props);

        this.openInNewTab = this.openInNewTab.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    
    
    
    handleSubmit() {
        
        let { logoutAction } = this.props;
         console.log(" I am calling logoutAction in handleSubmit")
        logoutAction();
         window.location.reload();
				 
        
    };
    componentDidMount(){
        let { logoutAction } = this.props;
        //this.props.auth.login();
        logoutAction();
        window.location.reload();
    }

handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

   openInNewTab(url) {
        var win = window.open(url, '_self');
       win.focus();
    }

    render() {
        const { classes } = this.props;
        //this.openInNewTab("/");
        let { logoutAction } = this.props;
        logoutAction();
        return(<div></div>);
         /*return(<Link to="/home"   >
            <Button  size="large"  variant="contained"   style = { { backgroundColor:'#D4E0EA',fontSize:32, color:'black' ,border: '2px solid', borderSize:5,   borderRadius:5, bordered:'true', borderColor:'black', textTransform:'none', width:'50%', marginTop:'20', marginLeft:'30'}}  onClick={this.handleSubmit}    >
                Logout from TowWatch
            </Button>
        </Link>);*/
         /*return (
            <div >

                <Grid container spacing={8}>

            this.openInNewTab("/home");
              </Grid>
            </div>


    );*/
    }
}


const mapStateToProps = (state) => {
    return {
        //accountsArray: state.account.accountsArray,
        //CompanyDeleteResponse:state.account.deleteCompanyResp,
        //CompanySaveResponse:state.account.saveCompanyResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        //errorCMsg:state.account.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        logoutAction:logoutAction,


    }, dispatch);
};

//export default withStyles(styles)(AppView);
//export default connect(mapStateToProps, mapDispatchToProps)(AppView);



/*Logout.propTypes = {
    classes: PropTypes.object.isRequired,
};*/
//export default withStyles(styles)(Login);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Logout));
